import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'ct-client-orders-nav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive],
  template: `
    <nav class="nav" aria-label="Vues des commandes">
      <a routerLink="/mes-commandes" routerLinkActive="active">Liste</a>
      <a routerLink="/mes-retraits" routerLinkActive="active">Calendrier</a>
    </nav>
  `,
  styles: `
    .nav {
      display: flex;
      gap: var(--ct-space-2);
      flex-wrap: wrap;
    }

    a {
      padding: var(--ct-space-2) var(--ct-space-3);
      border: 1px solid var(--ct-border);
      border-radius: var(--ct-radius-pill);
      text-decoration: none;
      color: var(--ct-text);
      font-size: var(--ct-size-sm);
      background: var(--ct-white);
    }

    a.active {
      border-color: var(--ct-vert-cageot);
      background: var(--ct-vert-cageot);
      color: var(--ct-kraft);
      font-weight: var(--ct-weight-bold);
    }
  `,
})
export class CtClientOrdersNav {}
